module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/order-groups/single-order-group/single-order-group-slots/single-order-group-slots.component.css
// module id = ./src/app/order-groups/single-order-group/single-order-group-slots/single-order-group-slots.component.css
// module chunks = main